var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveDetails({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.491 11.0801V12.0001C21.4897 14.1565 20.7759 16.2548 19.4559 17.9819C18.1359 19.7091 16.2805 20.9726 14.1664 21.584C12.0523 22.1954 9.79275 22.122 7.7248 21.3747C5.65685 20.6274 3.89126 19.2462 2.69136 17.4372C1.49146 15.6281 0.921541 13.4882 1.06659 11.3364C1.21165 9.18467 2.0639 7.13643 3.49626 5.49718C4.92861 3.85793 6.86432 2.71549 9.01469 2.24025C11.1651 1.76502 13.4149 1.98245 15.4286 2.86011",
    stroke: "#2148C0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4909 4L11.2677 14.01L8.20068 11.01",
    stroke: "#2148C0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveDetails);
export default __webpack_public_path__ + "static/media/active-details.ae34ef18c466a37e7013a10b80aaa3ad.svg";
export { ForwardRef as ReactComponent };